<template>
    <dx-grid
        :url="url"
        :columns="columns"
        :title="title"
        :actions="actions"
        :onRowClicked="onRowClicked"
        navigationPath="onRowClicked"
        navigationField="onRowClicked"
        :beforeSetupGrid="beforeSetupGrid"
        ref="grid"
        :expandedOptions="{
            enabled: true,
            allowExpandingAll: true,
            template: 'ykc-account-details',
        }"
    ></dx-grid>
</template>

<script>
import { formatCurrency } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Accounts",

        actions: [],

        regID: "",
        url: "",
        phoneSearch: "",

        columns: [
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "nameH",
                label: "Hebrew Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                //link: "YKCAccountView",
                //template: "link-cell-template",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "homePhone",
                label: "Home Phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "emailAddress",
                label: "Email Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "students",
                label: "Students",
                format: "",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "address1",
                label: "Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "cellPhone",
                label: "Cellphone",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "followUpDate",
                label: "Follow Up Date",
                format: "",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "followUpNote",
                label: "Follow Up Note",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {},
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Phone Number",
                type: "input",
                inputType: "number",
                mask: "###-###-####",
                align: "left",
                value: this.phoneSearch,
                onChanged: this.onPhoneNumberSearch,
                clearable: true,
            });

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms.map((t) => t.term),
                value: this.regID,
                onSelected: this.onTermSelected,
            });
            // this.actions.push({
            //     text: "Add Family",
            //     action: this.addFamily,
            // });

            this.url = "yKCAccountsBasic?phone=&regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/yk/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/yk/getRegTerms");
        },
        async onRowClicked(row) {
            this.$router.push({
                name: "YKCAccountView",
                params: { id: row.accountID, reg_id: row.regID },
            });
        },
        addFamily() {
            this.$router.push({
                name: "YKApply",
            });
        },
        onTermSelected(value) {
            this.regID = value;

            this.reloadDataSource();
        },
        onPhoneNumberSearch(value) {
            this.phoneSearch = value ? value.replaceAll("-", "") : "";

            this.reloadDataSource();
        },
        reloadDataSource() {
            this.url =
                "yKCAccountsBasic?regID=" +
                this.regID +
                (this.phoneSearch ? "&phone=" + this.phoneSearch : "&phone=");

            this.$refs.grid.reloadDataSource(this.url);
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.yk-accounts-list.container {
    padding-right: 0px !important;
    padding-left: 0px !important;
}
</style>
